export default function DollarIco() {
  return (
    <svg
      width="10"
      height="15"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7.5512C6 6.39165 5.34527 5.6829 3.7225 5.14145C2.56376 4.72915 2.08641 4.4586 2.08641 4.03335C2.08641 3.6725 2.37267 3.3113 3.25886 3.3113C3.78583 3.3113 4.21022 3.39635 4.54611 3.4975C4.72497 3.55105 4.91976 3.53285 5.08419 3.4464C5.24824 3.3603 5.36823 3.21435 5.41489 3.0425L5.42229 3.01555C5.48006 2.80275 5.44525 2.577 5.32564 2.3887C5.20602 2.2004 5.0116 2.0653 4.78571 2.0135C4.48093 1.9435 4.12357 1.8931 3.70325 1.87175V1.1C3.70325 0.9068 3.53771 0.75 3.33292 0.75H2.59227C2.38785 0.75 2.22195 0.9068 2.22195 1.1V1.97885C0.815455 2.26795 0 3.1405 0 4.2521C0 5.5023 0.995433 6.1463 2.45451 6.6104C3.46365 6.93275 3.89952 7.24215 3.89952 7.73145C3.89952 8.24735 3.36773 8.5305 2.59079 8.5305C2.03382 8.5305 1.50944 8.4234 1.05468 8.2708C0.863967 8.20675 0.653993 8.2211 0.475497 8.31105C0.297 8.40065 0.166646 8.5571 0.116282 8.74225L0.112949 8.75345C-0.00777682 9.1997 0.266263 9.6568 0.733243 9.78875C1.17578 9.91405 1.69387 10.0015 2.22195 10.0246V10.9C2.22195 11.0935 2.38785 11.25 2.59227 11.25H3.33292C3.53771 11.25 3.70325 11.0935 3.70325 10.9V9.90495C5.18455 9.6141 6 8.6642 6 7.5512Z"
        fill="#0057D2"
      />
    </svg>
  );
}
